import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/ad/2025/sidebar_banner_202504.jpg'


const _hoisted_1 = { class: "timeline-container" }
const _hoisted_2 = { class: "lineleft" }
const _hoisted_3 = { class: "entry-list" }
const _hoisted_4 = { class: "nav-tab" }
const _hoisted_5 = { class: "article-list" }
const _hoisted_6 = { class: "flow-header" }
const _hoisted_7 = ["href", "title"]
const _hoisted_8 = { class: "user" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "name" }
const _hoisted_11 = { class: "info" }
const _hoisted_12 = { class: "date" }
const _hoisted_13 = { class: "content-wrapper" }
const _hoisted_14 = { class: "info" }
const _hoisted_15 = ["href", "title"]
const _hoisted_16 = { class: "title" }
const _hoisted_17 = ["href"]
const _hoisted_18 = { class: "content" }
const _hoisted_19 = {
  key: 0,
  class: "img"
}
const _hoisted_20 = { class: "user-image" }
const _hoisted_21 = ["href"]
const _hoisted_22 = ["src"]
const _hoisted_23 = {
  key: 1,
  style: {"text-align":"center","padding-top":"50px"}
}
const _hoisted_24 = { key: 2 }
const _hoisted_25 = { class: "index-aside-footer" }
const _hoisted_26 = { class: "more-list" }
const _hoisted_27 = { class: "item" }
const _hoisted_28 = ["src"]
const _hoisted_29 = { class: "more-list" }
const _hoisted_30 = { class: "item" }

import { onMounted, reactive, ref, onUnmounted } from "vue";
import { useRouter } from "vue-router";
import MainHeader from "@/components/main-header.vue";
import axiosInstance from "@/utils/axiosInstance";
import { format } from "date-fns";
import { useHead } from "@vueuse/head";

interface Article {
  article_id: string;
  title: string;
  brief_content: string;
  cover_image: string;
  uuid: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {

const SSRData = ref({
  title: "默认代码",
  description:
    "默认代码,defaultcode.cn 是宁波的开发者技术社区，为开发者提供纯粹、高质的技术交流平台，让有意思的人聚在一起。",
  keywords:
    "默认代码,默认代码社区,宁波技术社区,宁波开发者技术交流社区,程序员中文技术社区",
  copyright:new Date().getFullYear()
});

// 使用组合式 API 设置 head
useHead({
  title: SSRData.value.title,
  meta: [
    { name: "description", content: SSRData.value.description },
    { name: "keywords", content: SSRData.value.keywords },
  ],
});

const router = useRouter();
const state = reactive({
  isActive: 1,
  sort: "",
});

//定义数据和接口类型
const formatDate = (date: string | Date) => {
  return format(new Date(date), "yyyy-MM-dd");
};

const articles = ref<Article[]>([]);
const currentPage = ref(1);
const isLoading = ref(false);
const loadCount = ref(0); // 自动加载计数器
const showLoadMore = ref(false); // 显示加载更多按钮
const hasMore = ref(true); // 是否还有更多数据

//信息流加载
const loadArticles = async (isAutoLoad: boolean) => {
  if (isLoading.value || !hasMore.value) return;
  isLoading.value = true;
  try {
    const response = await axiosInstance.get(
      "/api/HomeArticle/recommend_all_feed",
      {
        params: { page: currentPage.value, sort: state.sort },
      }
    );
    var result = response.data;
    if (result.success && result.data.dataCount > 0) {
      articles.value.push(...result.data.data);
      currentPage.value++;
      hasMore.value = currentPage.value <= result.data.pageCount;
      if (isAutoLoad) {
        loadCount.value++;
        showLoadMore.value = loadCount.value >= 5;
      }
    } else {
      hasMore.value = false;
    }
  } finally {
    isLoading.value = false;
  }
};

const handleScroll = () => {
  const scrollHeight = document.documentElement.scrollHeight;
  const clientHeight = window.innerHeight;
  const scrollTop = document.documentElement.scrollTop;

  // 距离底部50px时触发加载
  if (scrollHeight - (scrollTop + clientHeight) < 50) {
    if (hasMore.value && !showLoadMore.value && !isLoading.value) {
      loadArticles(true);
    }
  }
};

onMounted(async () => {
  window.addEventListener("scroll", handleScroll);
  loadArticles(false); // 初始加载
});

onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll);
});

const handleManualLoad = () => {
  if (!isLoading.value && hasMore.value) {
    loadArticles(false);
    showLoadMore.value = false; // 加载后隐藏按钮
  }
};

//tab切换
const handleTabClick = (tab: number) => {
  state.isActive = tab;
  if (tab === 1) {
    router.push({ path: "/" });
    state.sort = "";
    reFreshPage();
  } else {
    router.push({ path: "/", query: { sort: "newest" } });
    state.sort = "newest";
    reFreshPage();
  }
};

const reFreshPage = () => {
  currentPage.value = 1;
  isLoading.value = false;
  loadCount.value = 0;
  showLoadMore.value = false;
  hasMore.value = true;
  articles.value = [];
  loadArticles(false);
};

return (_ctx: any,_cache: any) => {
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(MainHeader),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                class: _normalizeClass(["tabItem", { active: state.isActive === 1 }]),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (handleTabClick(1)))
              }, " 推荐 ", 2),
              _createElementVNode("div", {
                class: _normalizeClass(["tabItem", { active: state.isActive === 2 }]),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (handleTabClick(2)))
              }, " 最新 ", 2)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_skeleton, {
                loading: isLoading.value,
                style: {"margin-top":"15px"},
                rows: 4,
                animated: ""
              }, {
                template: _withCtx(() => [
                  _createVNode(_component_el_skeleton_item, {
                    variant: "text",
                    style: {"width":"45%"}
                  }),
                  _createVNode(_component_el_skeleton_item, {
                    variant: "text",
                    style: {"width":"60%"}
                  }),
                  _createVNode(_component_el_skeleton_item, {
                    variant: "text",
                    style: {"width":"85%"}
                  }),
                  _createVNode(_component_el_skeleton_item, {
                    variant: "text",
                    style: {"width":"100%"}
                  })
                ]),
                _: 1
              }, 8, ["loading"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(articles.value, (articleitem) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "infor-list",
                  key: articleitem.article_id
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("a", {
                      href: `/user/${articleitem.uuid}`,
                      target: "_blank",
                      title: '查看' + articleitem.author + ' 的个人主页',
                      class: "titlelink"
                    }, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("img", {
                          src: articleitem.avatar_url,
                          class: "avatar"
                        }, null, 8, _hoisted_9),
                        _createElementVNode("span", _hoisted_10, _toDisplayString(articleitem.author), 1)
                      ])
                    ], 8, _hoisted_7),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, _toDisplayString(formatDate(articleitem.created_at)), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("a", {
                          href: `/post/${articleitem.article_id}`,
                          title: articleitem.title,
                          class: "titlelink",
                          target: "_blank"
                        }, [
                          _createElementVNode("h1", _hoisted_16, _toDisplayString(articleitem.title), 1)
                        ], 8, _hoisted_15),
                        _createElementVNode("a", {
                          href: `/post/${articleitem.article_id}`,
                          class: "titlelink",
                          target: "_blank"
                        }, [
                          _createElementVNode("div", _hoisted_18, _toDisplayString(articleitem.brief_content), 1)
                        ], 8, _hoisted_17)
                      ])
                    ]),
                    (articleitem.cover_image)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("a", {
                              href: `/post/${articleitem.article_id}`,
                              class: "titlelink",
                              target: "_blank"
                            }, [
                              _createElementVNode("img", {
                                class: "image-loct",
                                src: articleitem.cover_image,
                                width: "192",
                                height: "128",
                                loading: "lazy"
                              }, null, 8, _hoisted_22)
                            ], 8, _hoisted_21)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128)),
              (showLoadMore.value && hasMore.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "load-more",
                    onClick: handleManualLoad,
                    style: {"text-align":"center","padding-top":"50px"}
                  }, _toDisplayString(isLoading.value ? "加载中..." : "加载更多"), 1))
                : _createCommentVNode("", true),
              (isLoading.value && !showLoadMore.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, " 加载中... "))
                : _createCommentVNode("", true),
              (!hasMore.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, _cache[2] || (_cache[2] = [
                    _createElementVNode("div", { style: {"text-align":"center","padding-top":"50px"} }, " 暂无数据 ", -1)
                  ])))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "index-aside" }, null, -1)),
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "sidebar-block banner-block" }, [
          _createElementVNode("div", { class: "banner" }, [
            _createElementVNode("img", {
              src: _imports_0,
              class: "banner-image"
            })
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_25, [
          _cache[4] || (_cache[4] = _createStaticVNode("<ul class=\"more-list\" data-v-2f98105e><li class=\"item\" data-v-2f98105e><a href=\"https://x0pcacndwxb.feishu.cn/share/base/form/shrcn8CwaeQwQH3NSCO7JHidk1b\" target=\"_blank\" rel=\"nofollow\" data-v-2f98105e>问题反馈</a></li><li class=\"item\" data-v-2f98105e><a href=\"/about\" target=\"_blank\" data-v-2f98105e>关于我们</a></li></ul><ul class=\"more-list\" data-v-2f98105e><li class=\"item\" data-v-2f98105e> 联系我们：<a href=\"mailto:dcteams@163.com\" data-v-2f98105e>dcteams{at}163.com</a></li></ul><ul class=\"more-list\" data-v-2f98105e><li class=\"item\" data-v-2f98105e><a href=\"https://beian.miit.gov.cn/\" target=\"_blank\" rel=\"nofollow\" data-v-2f98105e>备案号：浙ICP备2025171302号</a></li></ul>", 3)),
          _createElementVNode("ul", _hoisted_26, [
            _createElementVNode("li", _hoisted_27, [
              _createElementVNode("img", {
                src: require('@/assets/img/police.20250527.png'),
                width: "20",
                height: "20",
                style: {"vertical-align":"middle"}
              }, null, 8, _hoisted_28),
              _cache[3] || (_cache[3] = _createElementVNode("a", {
                href: "https://beian.mps.gov.cn/#/query/webSearch?code=33020602001525",
                rel: "noreferrer",
                target: "_blank"
              }, "浙公网安备33020602001525号", -1))
            ])
          ]),
          _createElementVNode("ul", _hoisted_29, [
            _createElementVNode("li", _hoisted_30, [
              _createElementVNode("span", null, " © " + _toDisplayString(SSRData.value.copyright) + " 默认代码", 1)
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})